<!-- static content data from lang: footer -->
<template>
  <footer class="footer px-4 mx-2">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} {{lang.label.companyName}}
        </div>
      </div>
      <!-- <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          <li class="nav-item" v-for="(footer, index) in data.footerLink" :key="index">
            <router-link :to="footer.url" class="nav-link">{{footer.name}}</router-link>

          </li>
        </ul>
      </div> -->
    </div>
  </footer>
</template>
<script>
import jsondata from "../../assets/json/data.json";
export default {
  data() {
    return {
      lang: this.$lang.footer,
       data: jsondata,
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
